import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  implements OnInit {
  title = 'cheg-transaction';
  constructor(private router: Router){

  }
  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url.includes('/rewards-form')) {
          document.body.style.backgroundColor = '#f0f0f0';  // Set your desired color
        } else {
          document.body.style.backgroundColor = '';  // Reset or set default background
        }
      });
  }
}
